import styled from 'styled-components';
import { Modal, Form, Divider } from 'antd';
export const EmployeeModal = styled(Modal)`
  .ant-modal-content {
    width: 1000px;
    .ant-modal-close-x {
      margin-top: -10px;
      margin-right: -10px;
    }
    .ant-modal-body {
      padding-bottom: 0px;
    }
  }
`;

export const EmployeeAddModalContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  height: 100%;
  margin-right: -15px;
`;

export const EmployeeAddModalContentLeft = styled.div`
  height: 100%;
  min-width: 200px;
`;

export const EmployeeAddModalContentRight = styled.div`
  width: 100%;
  height: 100%;
`;

export const EmployeeAddModalDivider = styled(Divider)`
  height: 620px;
  border-left-width: 5px;
  border-radius: 2px;
`;

export const EmployeeModalForm = styled(Form)`
  padding-top: 15px;
  padding-right: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 630px;

  .ant-form-item-label > label.ant-form-item-required::before {
    content: none;
  }

  .ant-form-item-label > label.ant-form-item-required::after {
    display: inline-block;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }

  &::-webkit-scrollbar-track {
    margin-top: 20px;
  }
  &::-webkit-scrollbar {
    background-color: var(--cl_white);
  }
`;
